/**
 * Authors: mariushirjanu
 * Created: 20/10/2021
 */
import { Component, Input } from '@angular/core';
import { IDialogButton } from '../ga-message.service';

@Component({
  selector: 'default-dialog-wrapper',
  template: `
    <default-dialog [title]="title" [closeButton]="closeButton" [windowClass]="windowClass" [dialogClass]="dialogClass" [hideHeader]="hideHeader" [hideFooter]="hideFooter" [message]="message" [buttons]="buttons">
      <ndc-dynamic [ndcDynamicComponent]="component" [ndcDynamicInputs]="inputs" [ndcDynamicOutputs]="outputs"></ndc-dynamic>
    </default-dialog>
  `
})
export class DefaultDialogWrapperComponent {
  @Input() public component;
  @Input() public inputs;
  @Input() public outputs;
  @Input() public hideHeader;
  @Input() public hideFooter;
  @Input() public windowClass;
  @Input() public dialogClass;
  @Input() public message:string;
  @Input() public buttons?:IDialogButton[];

  public title:string;
  public closeButton:boolean;

  constructor() {
    /***/
  }
}